// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blog-list__items{display:grid;grid-row-gap:20px;grid-auto-flow:row}.blog-list__link{text-decoration:none;color:#ff6361}@media(-ms-high-contrast:active),(-ms-high-contrast:none),(any-hover:hover){.blog-list__link:focus,.blog-list__link:hover{text-decoration:underline}}@media(any-hover:none){.blog-list__link:active{text-decoration:underline}}.blog-list__link:active{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
